@if (!isVisible()) {
  <button
    type="button"
    class="tw:fixed tw:right-0 tw:flex tw:items-center tw:justify-center tw:w-10 tw:h-10 tw:p-0 tw:border-0 tw:bg-(--p-primary-color) tw:cursor-grab tw:touch-none tw:transition-[width,background] tw:duration-150 tw:ease-out tw:hover:w-14 tw:active:cursor-grabbing tw:rounded-s-2xl tw:shadow-md"
    [style.top.px]="topPx()"
    [pTooltip]="'Ask' + ' ' + botName()"
    tooltipPosition="left"
    test-id="ai-chat-handle"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)">
    <i class="pi pi-sparkles tw:text-primary-contrast"></i>
  </button>
}
